// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"about-module--pageContainer--3Xmjp","pageText":"about-module--pageText--20Cg7","tutorialButton":"about-module--tutorialButton--HdExU"};